export default __webpack_public_path__ + "static/media/pdf.b051cc10.svg";